import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Icon } from "@circle-react-shared/Icon";

interface BroadcastModeIndicatorProps {
  agentName: string;
}

export const BroadcastModeIndicator = ({
  agentName,
}: BroadcastModeIndicatorProps) => (
  <div className="bg-warning-light mx-1 my-4 rounded-lg p-4">
    <div className="flex items-center gap-2">
      <Icon type="16-info" size={16} />
      <Typography.LabelMd weight="semibold" color="text-secondary">
        {t("community_inbox.broadcast_mode", { agent_name: agentName })}
      </Typography.LabelMd>
    </div>
  </div>
);
